import { useState } from 'react';
import { useTranslation } from '../../i18n';

// TODO(api): replace with GET /api/v1/cards.
const MOCK_CARDS = [
  { id: 'c1', name: 'Anna Nowak',         cardId: 'a7x9k2m4…e8', device: 'iPhone 15 Pro',  lastUsed: '2 hours ago', active: true },
  { id: 'c2', name: 'Tomek Zieliński',    cardId: 'b3f2j1n7…c2', device: 'Pixel 8',         lastUsed: '3 days ago',  active: true },
  { id: 'c3', name: 'Maria Wiśniewska',   cardId: 'd9k4m8q3…f1', device: null,              lastUsed: null,           active: false },
];

export function CardManager() {
  const { t } = useTranslation();
  const [cards, setCards] = useState(MOCK_CARDS);

  function toggle(id) {
    setCards((prev) => prev.map((c) => (c.id === id ? { ...c, active: !c.active } : c)));
  }

  return (
    <div>
      <header className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', flexWrap: 'wrap', gap: 'var(--space-3)' }}>
        <div>
          <h1 className="page-header__title">{t('cards.title')}</h1>
          <div className="page-header__subtitle">{t('cards.subtitle')}</div>
        </div>
        <button type="button" className="button button--primary">
          + {t('cards.generateNew')}
        </button>
      </header>

      <table className="data-table">
        <thead>
          <tr>
            <th>{t('cards.columns.name')}</th>
            <th>{t('cards.columns.cardId')}</th>
            <th>{t('cards.columns.device')}</th>
            <th>{t('cards.columns.lastUsed')}</th>
            <th>{t('cards.columns.status')}</th>
            <th aria-label="toggle" />
          </tr>
        </thead>
        <tbody>
          {cards.map((card) => (
            <tr key={card.id}>
              <td><strong>{card.name}</strong></td>
              <td><span className="mono">{card.cardId}</span></td>
              <td>{card.device || <span className="page-header__subtitle">{t('cards.notBound')}</span>}</td>
              <td>{card.lastUsed || <span className="page-header__subtitle">{t('cards.never')}</span>}</td>
              <td>
                <span className={`status-pill status-pill--${card.active ? 'active' : 'inactive'}`}>
                  {t(card.active ? 'cards.active' : 'cards.inactive')}
                </span>
              </td>
              <td style={{ textAlign: 'right' }}>
                <button
                  type="button"
                  className={'toggle' + (card.active ? ' toggle--on' : '')}
                  onClick={() => toggle(card.id)}
                  aria-label={t(card.active ? 'cards.deactivate' : 'cards.activate')}
                  aria-pressed={card.active}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
